module.exports = __webpack_public_path__ + "static/media/photo48.ffabc530.jpg";